import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';
import { contains, find, propEq, path, head } from 'ramda';

import { RadioButtonsLoad } from 'components/common/form/RadioButtons';
import RadioIcons from 'components/common/form/RadioIcons';
import Text from 'components/common/form/Text';
import Select from 'components/common/form/Select';
import InputNumberMask from 'components/common/form/InputNumberMask';
import { PERCENTS } from 'constants/regexp';
import { getTranslateString } from 'helpers/eventHelper';
import { EVALUATIONS } from 'constants/events';
import { AutoFocusForm } from 'components/hocs/withAutoFocusForm';
import { required } from 'utils/validators';

const MAX_RESULT_TEXT_LENGTH = 255;

const isValueEmpty = (value, form) => {
    const tookPlace = path(['shortResultBlock', 'tookPlace'], form);
    return (!tookPlace || tookPlace === 1 || !!value) ? undefined : <Translate content="errors.required" />;
};

const wrapperCol = {
    xs: { span: 2 },
    sm: { span: 2 },
    md: { span: 2 }
};

export default class EventResultMetaForm extends Component {
    static propTypes = {
        change: PropTypes.func.isRequired,
        tookPlace: PropTypes.number,
        shortResults: PropTypes.array,
        abortedResultReasons: PropTypes.array,
        isTookPlace: PropTypes.bool.isRequired,
        evaluatedScore: PropTypes.string,
        resultCode: PropTypes.string,
    }

    static defaultProps = {
        shortResults: [],
        abortedResultReasons: [],
    }

    onChangeTookPlace = () => {
        this.props.change('shortResultBlock.resultCode', null);
        this.props.change('shortResultBlock.evaluatedScore', '');
        this.props.change('shortResultBlock.percent', '');
    }

    onChangeEvaluatedScore = value => {
        const { change, resultCode, shortResults } = this.props;

        if (resultCode) {
            const result = find(propEq('id', Number(resultCode)), shortResults);

            if (value && !contains(value, result.evaluatedScores)) {
                change('shortResultBlock.resultCode', null);
            }
        }
    }

    onChangeResultCode = value => {
        const { change, isTookPlace, shortResults } = this.props;

        if (isTookPlace) {
            if (!value) {
                return change('shortResultBlock.evaluatedScore', '');
            }

            const result = find(propEq('id', Number(value)), shortResults);

            if (result.evaluatedScores.length === 1) {
                change('shortResultBlock.evaluatedScore', head(result.evaluatedScores));
            }
        }
    }

    validateResultText = (value) => {
        return value && value.length > MAX_RESULT_TEXT_LENGTH ? <Translate content="errors.lengthNotMoreThan"  with={{ length: MAX_RESULT_TEXT_LENGTH }} /> : undefined;
    }

    render() {
        const { tookPlace, shortResults, abortedResultReasons, isTookPlace } = this.props;

        return (
            <div className='event-result-meta'>
                <Field
                    name='shortResultBlock.tookPlace'
                    component={RadioButtonsLoad}
                    namePath='name'
                    loadName={'yesno'}
                    onChange={this.onChangeTookPlace}
                    radioTranslate='events.tookPlaceRadio'
                    label={{ content: 'events.isHappened' }}
                    validate={required}
                />
                { tookPlace &&
                    <AutoFocusForm>
                        { isTookPlace && (
                            <Field
                                name="shortResultBlock.evaluatedScore"
                                component={RadioIcons}
                                options={EVALUATIONS}
                                namePath="value"
                                className="event-evaluate"
                                label={{content: "events.appreciate"}}
                                onChange={this.onChangeEvaluatedScore}
                            />
                        )}
                        <Field
                            name="shortResultBlock.resultCode"
                            component={Select}
                            namePath="text"
                            validate={isValueEmpty}
                            options={isTookPlace ? shortResults : abortedResultReasons}
                            label={{ content: getTranslateString(tookPlace) }}
                            onChange={this.onChangeResultCode}
                            allowClear
                        />
                        { isTookPlace && (
                            <Field
                                name="shortResultBlock.percent"
                                component={InputNumberMask}
                                mask={PERCENTS}
                                label={{ content: "events.percent" }}
                                containerClass="percent-input"
                                step='10'
                                wrapperCol={wrapperCol}
                            />
                        )}
                        <Field
                            name="shortResultBlock.comment"
                            component={Text}
                            label={{ content: "events.comment" }}
                            validate={this.validateResultText}
                        />
                    </AutoFocusForm>
                }
            </div>
        );
    }
}
